import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import orderManagement from "@/views/order/orderManagement.vue";
import consumerManagement from "@/views/consumer/consumerManagement.vue";
import ConferenceManagement from "@/views/conference/ConferenceManagement.vue";
import Submission from "@/views/submission/Submission.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/conference-management",
  },
  {
    path: "/conference-management",
    name: "ConferenceManagement",
    component: ConferenceManagement,
  },
  {
    path: "/order-management",
    name: "orderManagement",
    component: orderManagement,
  },
  {
    path: "/consumer-management",
    name: "consumerManagement",
    component: consumerManagement,
  },
  {
    path: "/submission",
    name: "submission",
    component: Submission,
    meta: { hideLayout: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫 ，如果是某个路径则不展示菜单栏
router.beforeEach((to: any, from, next) => {
  // document.title = "CIC投稿系统";
  next();
});

export default router;
